import { render, staticRenderFns } from "./agregar_glosa.vue?vue&type=template&id=0b28f5be&scoped=true&"
import script from "./agregar_glosa.vue?vue&type=script&lang=ts&"
export * from "./agregar_glosa.vue?vue&type=script&lang=ts&"
import style0 from "./agregar_glosa.vue?vue&type=style&index=0&id=0b28f5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b28f5be",
  null
  
)

export default component.exports